import React, { useState, useRef, useEffect } from 'react';
import { Button, Container, Tooltip, Overlay, Image } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import ProfilePictureViewer from './PFPViewer';
import default_pfp from '../../imgs/muscle_default.svg'
import {useAuth} from '../../react-query/useAuth'
import { fetchImage } from '../../services/api_data';

const UpdateDetails = () => {
    const {userData, updateUserDetails, changePassword} = useAuth();    
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [showTooltip, setShowTooltip] = useState(false);
    const [profilePictureFile, setProfilePictureFile] = useState(null); // New state for the selected profile picture file
    const [profilePicture, setProfilePicture] = useState(null); // new state for the uploaded image
    const [hasNewProfilePic, setHasNewProfilePic] = useState(false); // new state to track changes
    const target = useRef(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
          // Create an object for user details with trimmed values
          const userDetails = {
            first_name: firstName.trim(),
            last_name: lastName.trim(),
            email: email.trim(),
          };
    
          // Call the updateUserDetails function from the useAuth hook
          if (userDetails){
            await updateUserDetails(userDetails, profilePictureFile);
          }
    
          // If old and new passwords are provided, call updateUserPassword with trimmed values
          if (oldPassword && newPassword) {
            await changePassword(oldPassword.trim(), newPassword.trim());
          }
    
          // Handle success or display a success message
          // ...
    
        } catch (error) {
          // Handle errors
          console.error("Failed to update details:", error);
        }
      };

    // This function handles the change in the profile picture input
    const handleProfilePicChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfilePictureFile(file); // Set the selected profile picture file
                setProfilePicture(reader.result); // Set the profile picture using the base64 data
                setHasNewProfilePic(true); // Set the flag to true when a new picture is uploaded
            };
            reader.readAsDataURL(file);
        }
    };
    

     // Use useEffect to set the initial state of profilePicture
    useEffect(() => {
        if (!hasNewProfilePic) { // Only run if there's no new picture uploaded
            const fetchInitialProfilePicture = async () => {
            if (userData.image_url && userData.image_url !== "") {
                try {
                    const fetchedImage = await fetchImage(userData.image_url);
                    setProfilePicture(fetchedImage);
                } catch (error) {
                    console.error("Failed to fetch initial profile picture:", error);
                    setProfilePicture(default_pfp); // Fallback to default if fetch fails
                }
            } else {
                setProfilePicture(default_pfp); // Fall back to default_pfp if no image_url
            }
        };
        fetchInitialProfilePicture();
    }
}, [userData, hasNewProfilePic]); // Include hasNewProfilePic in the dependency array


    useEffect(() => {
        const timer = setTimeout(() => {
            setShowTooltip(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, [showTooltip]);
    
    return (
        // <Container>
        //     <h1 style={{ textAlign: "center" }}>Update Details</h1>
        //     <Form onSubmit={handleSubmit}>
        <Container>
        <h1 style={{ textAlign: "center" }}>Update Details</h1>
        <Form onSubmit={handleSubmit}>
            {/* Profile Picture Upload */}
            <Form.Group>
                <Form.Label>Profile Picture</Form.Label>
                {/* <Form.File onChange={handleProfilePicChange} /> */}
                <input type="file" onChange={handleProfilePicChange} />
                <ProfilePictureViewer src={profilePicture ? profilePicture : default_pfp} size={150} alt="Updated Profile"/>
            </Form.Group>
                <Form.Group controlId="firstName">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter your first name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId="lastName">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter your last name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}

                    />
                </Form.Group>
                <Form.Group controlId="old_password">
                    <Form.Label>Old Password</Form.Label>
                    <Form.Control
                        type="old_password"
                        placeholder="Enter your old password"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        required={!!newPassword} // Required if newPassword is not empty
                    />
                </Form.Group>
                <Form.Group controlId="new_password">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                        type="new_password"
                        placeholder="Enter your new password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required={!!oldPassword} // Required if oldPassword is not empty
                    />
                </Form.Group>
                <Button type="submit" style={{marginTop:"10px"}} onSubmit={handleSubmit}>Update</Button>
            </Form>
        </Container>
    );
}

export default UpdateDetails;
